import React from 'react';

const ChummeryItem = () => {
    <>
    ChummeryItem
    </>
}

export default ChummeryItem